<template>
  <section class="tag-list">
    <TheListTitle :listTitle="articleTitle" prefix="tag" />
    <AccesskeyLink
      id="mainContent"
      class="accesskey-c"
      accesskey="C"
      title=":::主要內容顯示區"
    />
    <div v-for="item in tagList" :key="item.id" class="tags">
      <div class="tags__title">
        {{ item.title }}
      </div>
      <div class="tags__group">
        <router-link
          v-for="tag in item.tags"
          :key="tag.id"
          :to="
            tag.pathName
              ? { name: 'tags' }
              : { name: 'tag', params: { tagId: tag.id } }
          "
          :title="`[前往]有${tag.name}標籤的導覽`"
          :style="`background-color: ${tag.tagGroupInfo.color}`"
          class="tags__tag"
          >{{ tag.name }}</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
import { getArticleString } from "@/config/articleString";
import TheListTitle from "@/components/list/TheListTitle";
import AccesskeyLink from "@/components/a11y/AccesskeyLink.vue";

export default {
  name: "TheTagList",
  metaInfo() {
    return {
      title: "標籤檢索",
      meta: [
        {
          vmid: "og:url",
          property: "og:url",
          content: this.productionWholeReference,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "臺南宗教藝術-標籤檢索",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "這裡有關於廟宇宗教的相關資訊標籤，讓您更方便的查詢到你想看的主題。",
        },
      ],
    };
  },
  data() {
    return {};
  },
  computed: {
    tagList() {
      return this.$store.getters.tagList;
    },
    articleTitle() {
      return getArticleString("tag", "headline");
    },
    productionWholeReference() {
      return `${this.$store.getters.productionHostname}${window.location.pathname}${window.location.search}`;
    },
  },
  created() {
    this.getTagList();
  },
  mounted() {},
  methods: {
    async getTagList() {
      // 載入標籤列表頁，以 API 資料作為初始值
      try {
        await this.$store.dispatch("getTagList");
      } catch (e) {
        console.error(e);
      }
    },
  },
  components: {
    TheListTitle,
    AccesskeyLink,
    // TheTags,
  },
};
</script>

<style lang="scss" scoped>
.tag-list {
  margin-bottom: 10px;
}

.tags {
  width: 100%;
  max-width: 290px;
  margin: auto;
  padding-top: 20px; // 標籤列表頁的距離
  padding-bottom: 20px;
  font-family: $text-font-family;
  font-size: 1.3125rem;
  letter-spacing: 1.5px;

  @include for-tablet {
    max-width: 630px;
  }

  @include for-tablet-horizontal {
    max-width: 900px;
  }

  &__title {
    text-align: center;
    margin-bottom: 20px;
    color: $color-light-text;
    font-size: 21px;
    font-weight: 600;
    letter-spacing: 1.5px;
  }

  &__group {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  &__tag {
    display: block;
    box-sizing: border-box;
    background-color: $color-tag-bg;
    color: $color-tag-text;
    padding: 7px 14px;
    border-radius: 5px;
    text-align: center;
    flex: 0 0 auto;
    min-width: 120px;
    max-width: 120px;
    line-height: 1.75;
    margin: 0 10px 10px 0;
    font-family: $text-font-family;
    font-size: 1.125rem;
    letter-spacing: 0.9px;

    @include truncate-string(100%);

    &:hover {
      background-color: darken($color-tag-bg, 10);
      color: $color-tag-text;
    }

    &:nth-child(2n) {
      margin-right: 0;

      @include for-tablet {
        margin-right: 10px;
      }
    }
  }

  &__group:nth-child(3n + 1) {
    margin-left: 0;

    @include for-tablet {
      margin-left: 10px;
    }
  }
}
</style>
